export enum ShuffleAction {
    GetShuffleQueueData = 1,
}
